import { useGateValue } from "@statsig/react-bindings";

/**
 * Returns whether the email-broadcast governance UI (Sending status / Sender
 * configuration tabs on the email channel detail page) is enabled for the
 * current org via the Statsig gate `enable_email_broadcast`.
 */
export const useEnableEmailBroadcast = (): boolean => {
  return useGateValue("enable_email_broadcast");
};
